import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import './Footer-with-button-logo.css'

class FooterComp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      version_information: {
        date: '',
        version: ''
      }
    }
    this.updateDate = ''
  }

  componentDidMount() {
    const fullPath = window.location.href
    const position = fullPath.indexOf(this.props.location.pathname)
    let target = fullPath + 'deployment-time.txt'

    if (this.props.location.pathname != '/') target = fullPath.substr(0, position) + '/deployment-time.txt'
    // console.log('target', target )

    fetch(target)
      .then(r => r.text())
      .then(timestamp => {
        // console.log("This is timestamp: ", timestamp);
        this.updateDate = timestamp
        var d = new Date(timestamp)
        this.setState({
          version_information: {
            date: d.toLocaleDateString() + ' ' + d.toLocaleTimeString(),
            version: '0.0.0.0'
          }
        })
      })
      .catch(error => console.log('parsing failed', error))
  }

  render() {
    // console.log(window.location.href, this.props.location.pathname)
    return (
      <div className="content">
        <div id="myFooter">
          <div className="container-footer ">
            <div className="row" style={{ flexDirection: 'nowrap', textAlign: 'center' }}>
              <div className="hidden-xs col-lg-2 " />
              <div className="col-3 col-lg-2 mt-4">
                <a href="#" onClick={() => this.props.history.push('solutions')}>
                  Solutions
                </a>
              </div>
              <div className="col-3 col-lg-2 mt-4">
                <a href="#" onClick={() => this.props.history.push('products')}>
                  Products
                </a>
              </div>
              <div className="col-3 col-lg-2 mt-4">
                <a href="#" onClick={() => this.props.history.push('services')}>
                  Services
                </a>
              </div>
              <div className="col-3 col-lg-2 mt-4">
                <a href="#" onClick={() => this.props.history.push('about_us')}>
                  About Us
                </a>
              </div>
              <div className="hidden-xs col-lg-2" />
              {/* <div className="col-sm-3"> */}
              {/* <div className="social-networks">
                  <a href="#" className="twitter">
                    <i className="fa fa-twitter">
                      <FontAwesomeIcon icon={faTwitter} />
                    </i>
                  </a>

                  <a href="#" className="facebook">
                    <i className="fa fa-facebook">
                      <FontAwesomeIcon icon={faFacebook} />
                    </i>
                  </a>
                  <a href="#" className="google">
                    <i className="fa fa-google-plus">
                      <FontAwesomeIcon icon={faInstagram} />
                    </i>
                  </a>
                </div> */}
              {/* <button type="button" className="btn btn-default">
                  Contact us
                </button> */}
              {/* </div> */}
            </div>
          </div>
          <hr style={{ borderColor: 'lightgray', margin: '1rem 0 0 0' }} />
          <div className="footer-copyright ml-md-4 mr-md-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <p style={{ float: 'left' }}>
              &copy;
              {new Date().getFullYear()} OpenZNet, Inc. All Rights Reserved
            </p>
            <a href="/privacy-policy">Privacy & Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
            <p className="footer-timestamp" style={{ float: 'right' }}>
              Update on {this.state.version_information.date}
            </p>
          </div>
        </div>
        <div style={{ clear: 'both' }} />
      </div>
    )
  }
}

export default withRouter(FooterComp)
